(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5050],{

/***/ 8939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Card; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./styles/modules/Card.module.scss
var Card_module = __webpack_require__(76136);
var Card_module_default = /*#__PURE__*/__webpack_require__.n(Card_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/Svg/Remove.js
var Remove = __webpack_require__(6607);
;// CONCATENATED MODULE: ./components/Svg/SendOutline.js

function Send() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "19",
        height: "19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M18.038 1.038l-9.336 9.336M18.038 1.038l-5.94 16.975-3.396-7.639L1.063 6.98l16.975-5.941z",
            stroke: "#BDBDBD",
            strokeWidth: "1.4",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}

;// CONCATENATED MODULE: ./components/Svg/Card/ChevronRight.js

function ChevronRight(props) {
    var _fill;
    var fill = (_fill = props.fill) !== null && _fill !== void 0 ? _fill : "var(--color-blue)";
    var _stroke;
    var stroke = (_stroke = props.stroke) !== null && _stroke !== void 0 ? _stroke : "var(--color-blue)";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "28",
        height: "28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "14.49",
                cy: "13.538",
                r: "13",
                stroke: stroke
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: fill,
                d: "M17.53 12.123l1.413 1.415-5.656 5.657-1.415-1.415z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: fill,
                d: "M11.871 9.295l1.414-1.414 5.657 5.657-1.414 1.414z"
            })
        ]
    });
}

// EXTERNAL MODULE: ./helpers/getCharacters.js
var getCharacters = __webpack_require__(51091);
// EXTERNAL MODULE: ./components/Button.js + 2 modules
var Button = __webpack_require__(44217);
// EXTERNAL MODULE: ./utils/tag-remove.js
var tag_remove = __webpack_require__(92131);
// EXTERNAL MODULE: ./utils/safe-html.js
var safe_html = __webpack_require__(95460);
// EXTERNAL MODULE: ./components/Typo.js
var Typo = __webpack_require__(23775);
// EXTERNAL MODULE: ./helpers/date.js
var date = __webpack_require__(36027);
// EXTERNAL MODULE: ./components/Svg/NewsAlertLogo.js
var NewsAlertLogo = __webpack_require__(99652);
;// CONCATENATED MODULE: ./components/Card.js













var isoDate = function(value) {
    // `new Date(null)` is the epoch, not an invalid date — guard falsy first
    var date = value ? new Date(value) : null;
    return !date || Number.isNaN(date.getTime()) ? undefined : date.toISOString().slice(0, 10);
};
var CardOverlay = function(param) {
    var link = param.link;
    if (!link) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: link,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: (Card_module_default()).overlayLink
        })
    });
};
var CardRemove = function(param) {
    var onRemove = param.onRemove, id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: (Card_module_default()).close,
        onClick: function() {
            return onRemove(id);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Remove/* default */.Z, {
            fill: "#C4C4C4",
            fillCross: "#FFF"
        })
    });
};
var CardActionOpen = function(param) {
    var link = param.link;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        className: (Card_module_default()).action,
        href: link,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight, {})
    });
};
var CardApproval = function(param) {
    var status = param.status, onApprove = param.onApprove, id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        theme: "primary",
        classes: [
            (Card_module_default()).button
        ],
        onClick: function() {
            return onApprove(id);
        },
        title: status === "pinned" ? "UNPIN" : "PIN"
    });
};
var CardTitle = function(param) {
    var linkOverlay = param.linkOverlay, title = param.title, link = param.link, _titleLimit = param.titleLimit, titleLimit = _titleLimit === void 0 ? 50 : _titleLimit;
    if (linkOverlay) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typo/* default */.Z, {
            Tag: "h3",
            variant: "h4",
            className: [
                "pb-xs",
                (Card_module_default()).title
            ].join(" "),
            children: (0,getCharacters/* default */.Z)(title, titleLimit)
        });
    }
    // The styled block goes inside the link, as the internal branch already
    // did, so a real h3 renders with the classes the anchor used to carry.
    if (link) {
        // External link
        if (link.includes("http")) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: link,
                target: "_blank",
                rel: "noreferrer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typo/* default */.Z, {
                    Tag: "h3",
                    variant: "h4",
                    className: [
                        "pb-xs",
                        (Card_module_default()).title
                    ].join(" "),
                    children: (0,getCharacters/* default */.Z)(title, titleLimit)
                })
            });
        }
        // Internal link
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: link,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typo/* default */.Z, {
                    Tag: "h3",
                    variant: "h4",
                    className: [
                        "pb-xs",
                        (Card_module_default()).title
                    ].join(" "),
                    children: (0,getCharacters/* default */.Z)(title, titleLimit)
                })
            })
        });
    }
    return null;
};
var CardBody = function(param) {
    var body = param.body, _limit = param.limit, limit = _limit === void 0 ? 300 : _limit;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typo/* default */.Z, {
        variant: "body",
        className: (Card_module_default()).body,
        dangerouslySetInnerHTML: {
            __html: (0,safe_html/* default */.ZP)((0,getCharacters/* default */.Z)((0,tag_remove/* default */.Z)(body), limit))
        }
    });
};
var CardCta = function(param) {
    var status = param.status, cta = param.cta, link = param.link, onApprove = param.onApprove, id = param.id;
    if (link.includes("http")) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Card_module_default()).wrapperCta,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: [
                        "mt-xs",
                        (Card_module_default()).cta
                    ].join(" "),
                    href: link,
                    target: "_blank",
                    rel: "noreferrer",
                    children: cta
                }),
                onApprove && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardApproval, {
                    status: status,
                    onApprove: onApprove,
                    id: id
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Card_module_default()).wrapperCta,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: link,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: [
                        "mt-xs",
                        (Card_module_default()).cta
                    ].join(" "),
                    children: cta
                })
            }),
            onApprove && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardApproval, {
                status: status,
                onApprove: onApprove,
                id: id
            })
        ]
    });
};
var Card = function(param) {
    var id = param.id, pretitle = param.pretitle, title = param.title, body = param.body, publishedAt = param.publishedAt, status = param.status, cta = param.cta, link = param.link, linkOverlay = param.linkOverlay, quotedOn = param.quotedOn, onRemove = param.onRemove, onEdit = param.onEdit, editLabel = param.editLabel, _onApprove = param.onApprove, onApprove = _onApprove === void 0 ? null : _onApprove, _limit = param.limit, limit = _limit === void 0 ? 300 : _limit, _titleLimit = param.titleLimit, titleLimit = _titleLimit === void 0 ? 50 : _titleLimit, _alert = param.alert, alert = _alert === void 0 ? false : _alert, _author = param.author, author = _author === void 0 ? null : _author, _feed = param.feed, feed = _feed === void 0 ? false : _feed;
    var isNonDefaultStatus = status && status !== "publish";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: [
            (Card_module_default()).card
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: [
                    "p-card",
                    (Card_module_default()).cardWrapper
                ].join(" "),
                children: [
                    isNonDefaultStatus && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: [
                            (Card_module_default()).card__status,
                            status === "new" ? (Card_module_default())["card__status--new"] : "", 
                        ].join(" "),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: status.toUpperCase()
                        })
                    }),
                    linkOverlay && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardOverlay, {
                        link: link
                    }),
                    onRemove && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardRemove, {
                        onRemove: onRemove,
                        id: id
                    }),
                    link && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActionOpen, {
                        link: link
                    }),
                    alert && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: [
                            "mb-xs",
                            (Card_module_default()).logo
                        ].join(" "),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsAlertLogo/* default */.Z, {})
                    }),
                    pretitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typo/* default */.Z, {
                        variant: "caption",
                        className: "mb-s",
                        children: pretitle
                    }),
                    quotedOn && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typo/* default */.Z, {
                        variant: "body",
                        className: (Card_module_default()).body,
                        children: [
                            "Quoted on: ",
                            (0,getCharacters/* default */.Z)(quotedOn, 120)
                        ]
                    }),
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTitle, {
                        title: title,
                        linkOverlay: linkOverlay,
                        link: link,
                        titleLimit: titleLimit
                    }),
                    body && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardBody, {
                        body: body,
                        limit: limit
                    }),
                    cta && link && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardCta, {
                        cta: cta,
                        link: link,
                        onApprove: onApprove,
                        id: id,
                        status: status
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Card_module_default()).card__actions,
                children: [
                    onEdit && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: (Card_module_default()).edit,
                        "aria-label": "".concat(editLabel, ": ").concat(title),
                        onClick: function() {
                            return onEdit(id);
                        },
                        children: editLabel
                    }),
                    publishedAt && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: (Card_module_default()).card__status,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Send, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    "Published:",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                        dateTime: isoDate(publishedAt),
                                        children: (0,date/* default */.Z)(publishedAt)
                                    }),
                                    feed && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            ", by ",
                                            alert ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "https://newspage.co.uk/about-us/",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: (Card_module_default()).authorLink,
                                                    children: "Dominic Hiatt"
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/".concat(author.slug),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: (Card_module_default()).authorLink,
                                                    children: author.name
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Card = (Card);


/***/ }),

/***/ 80326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_EmptyBlock; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/Svg/Chat.js

function Chat(props) {
    var _fill;
    var fill = (_fill = props.fill) !== null && _fill !== void 0 ? _fill : "#212121";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "26",
        height: "27",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M0 0h26v22H8l-8 5V0z",
            fill: fill
        })
    });
}

// EXTERNAL MODULE: ./styles/modules/EmptyBlock.module.scss
var EmptyBlock_module = __webpack_require__(30068);
var EmptyBlock_module_default = /*#__PURE__*/__webpack_require__.n(EmptyBlock_module);
// EXTERNAL MODULE: ./components/Typo.js
var Typo = __webpack_require__(23775);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./store/auth.js
var auth = __webpack_require__(32505);
;// CONCATENATED MODULE: ./components/EmptyBlock.js






// Empty-state copy is an instruction to the owner, not a fact about the member,
// and Google was lifting "No media coverage has been added yet" into the
// snippet for profiles with nothing to show. Gated here rather than in each
// caller so coverage, stories and alerts all stay out of the crawlable HTML.
var EmptyBlock = function(param) {
    var title = param.title;
    var isAuthorized = (0,es/* useSelector */.v9)(auth/* authSelector */.aF).isAuthorized;
    if (!isAuthorized) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (EmptyBlock_module_default()).block,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typo/* default */.Z, {
                variant: "h3",
                className: (EmptyBlock_module_default()).title,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Chat, {}),
                    title
                ]
            })
        })
    });
};
/* harmony default export */ var components_EmptyBlock = (EmptyBlock);


/***/ }),

/***/ 16111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25617);
/* harmony import */ var store_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32505);
/* harmony import */ var components_Typo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23775);
/* harmony import */ var lang_en_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64798);





// Replaces the Add Media Coverage control for members: only the editorial team
// adds coverage. Admins keep the real control, and a plain visitor has nothing
// to report.
var MissedCoverage = function(param) {
    var className = param.className;
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(store_auth__WEBPACK_IMPORTED_MODULE_2__/* .authSelector */ .aF), isAuthorized = ref.isAuthorized, isAdmin = ref.isAdmin;
    if (!isAuthorized || isAdmin) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Typo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        variant: "small",
        className: className,
        children: lang_en_json__WEBPACK_IMPORTED_MODULE_4__/* .profile.media_coverage.missed */ .N5.iT.oY
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MissedCoverage);


/***/ }),

/***/ 99652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NewsAlertLogo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



function NewsAlertLogo(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        width: "146",
        height: "32",
        viewBox: "0 0 146 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M7 7.5H5.5V9V22.4815V26V28.73L7.80434 27.2661L12.9746 23.9815H25H26.5V22.4815V9V7.5H25H7Z",
                stroke: "var(--color-blue)",
                strokeWidth: "3"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M51.3 9V17.5L44.34 9H41.66V23H44.86V14.5L51.84 23H54.5V9H51.3ZM68.1323 17.66C68.1323 14.2 65.6923 12.08 62.5323 12.08C59.2523 12.08 56.7923 14.4 56.7923 17.62C56.7923 20.82 59.2123 23.16 62.9323 23.16C64.8723 23.16 66.3723 22.56 67.3723 21.42L65.7123 19.62C64.9723 20.32 64.1523 20.66 63.0123 20.66C61.3723 20.66 60.2323 19.84 59.9323 18.5H68.0723C68.0923 18.24 68.1323 17.9 68.1323 17.66ZM62.5523 14.44C63.9523 14.44 64.9723 15.32 65.1923 16.68H59.8923C60.1123 15.3 61.1323 14.44 62.5523 14.44ZM84.5342 12.24L81.9142 19.52L79.3542 12.24H76.7142L74.0742 19.52L71.5342 12.24H68.5942L72.4742 23H75.4742L77.9742 16.32L80.3942 23H83.3942L87.2942 12.24H84.5342ZM92.2084 23.16C95.4284 23.16 97.2884 21.74 97.2884 19.74C97.2884 15.5 90.7884 17.28 90.7884 15.44C90.7884 14.88 91.3884 14.44 92.7884 14.44C93.7684 14.44 94.8284 14.64 95.8884 15.24L96.9284 13.02C95.9084 12.42 94.2684 12.08 92.7884 12.08C89.6484 12.08 87.8084 13.52 87.8084 15.56C87.8084 19.86 94.3084 18.06 94.3084 19.82C94.3084 20.42 93.7684 20.8 92.3284 20.8C91.0084 20.8 89.5484 20.38 88.5884 19.76L87.5484 22C88.5484 22.66 90.3884 23.16 92.2084 23.16ZM110.513 23H112.073L105.673 9H104.213L97.8134 23H99.3534L101.033 19.26H108.833L110.513 23ZM101.573 18.06L104.933 10.54L108.293 18.06H101.573ZM114.089 23H115.509V8.16H114.089V23ZM128.64 17.74C128.64 14.58 126.5 12.4 123.54 12.4C120.58 12.4 118.4 14.62 118.4 17.74C118.4 20.86 120.64 23.1 123.92 23.1C125.58 23.1 127.04 22.5 127.98 21.38L127.18 20.46C126.38 21.38 125.24 21.84 123.96 21.84C121.66 21.84 119.98 20.38 119.82 18.18H128.62C128.62 18.02 128.64 17.86 128.64 17.74ZM123.54 13.62C125.6 13.62 127.1 15.06 127.28 17.12H119.82C120 15.06 121.5 13.62 123.54 13.62ZM132.891 14.54V12.48H131.531V23H132.951V17.64C132.951 15.16 134.291 13.76 136.491 13.76C136.591 13.76 136.711 13.78 136.831 13.78V12.4C134.891 12.4 133.551 13.14 132.891 14.54ZM144.891 21.34C144.491 21.7 143.911 21.88 143.331 21.88C142.151 21.88 141.511 21.2 141.511 19.96V13.68H144.711V12.48H141.511V10.18H140.091V12.48H138.211V13.68H140.091V20.04C140.091 21.98 141.191 23.1 143.171 23.1C143.991 23.1 144.831 22.86 145.391 22.36L144.891 21.34Z",
                fill: "#232735"
            })
        ]
    }));
}


/***/ }),

/***/ 36027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ formatResponseReset; }
/* harmony export */ });
var formatDate = function(date) {
    var formattedDate = new Date(date);
    var hours = formattedDate.getHours();
    var minutes = formattedDate.getMinutes();
    var ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var timePart = hours + ":" + minutes + " " + ampm;
    return "".concat(formattedDate.getDate(), "/").concat(formattedDate.getMonth() + 1, "/").concat(formattedDate.getFullYear(), ", ").concat(timePart);
};
// The response allowance resets on a rolling 30-day boundary, not on the 1st of
// the month, so copy names the actual reset date rather than a calendar month.
var formatResponseReset = function(responsePeriodEnd) {
    if (!responsePeriodEnd) return null;
    var reset = new Date(responsePeriodEnd);
    if (Number.isNaN(reset.getTime())) return null;
    return reset.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (formatDate);


/***/ }),

/***/ 51091:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var getCharacters = function(text, n) {
    var textWithoutUrls = text.replace(RegExp("\\(?<a.*?<\\/a>\\)?", "gi"), "");
    var pos = textWithoutUrls === null || textWithoutUrls === void 0 ? void 0 : textWithoutUrls.indexOf(" ", n);
    var out = textWithoutUrls === null || textWithoutUrls === void 0 ? void 0 : textWithoutUrls.substring(0, pos);
    return pos <= 0 ? text : out + "...";
};
/* harmony default export */ __webpack_exports__["Z"] = (getCharacters);


/***/ }),

/***/ 76136:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"Card_cardWrapper__Ts5If","card":"Card_card__fBILh","card--add-button":"Card_card--add-button__VWyTM","card--add":"Card_card--add__W3FzD","addIcon":"Card_addIcon__Q_W7S","card--draft":"Card_card--draft__D97Ww","card__status":"Card_card__status__fLb7C","card__status--new":"Card_card__status--new__f1PHL","card__actions":"Card_card__actions__70_Wv","card__status--request-editing":"Card_card__status--request-editing__u7uOq","close":"Card_close__SqYus","button":"Card_button__xDhfQ","overlayLink":"Card_overlayLink__bA12D","action":"Card_action__tfgwc","title":"Card_title__gkvsT","body":"Card_body__3LyaM","wrapperCta":"Card_wrapperCta__1uidB","cta":"Card_cta__WPp6v","authorLink":"Card_authorLink__3Fd2O","edit":"Card_edit__f8km3"};

/***/ }),

/***/ 30068:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"block":"EmptyBlock_block__6WsR4","title":"EmptyBlock_title__wSuhr"};

/***/ })

}]);